export const CHART_HEIGHT = 400
export const AXIS_MARGIN_BOTTOM = 36
